const Buffer =
  typeof globalThis.Buffer === "undefined"
    ? require("buffer").Buffer
    : globalThis.Buffer;

const base64decode = (str: string) => Buffer.from(String(str), "base64");

export function parseLicense(licenseString: string) {
  const licenseKey = base64decode(licenseString);
  if (licenseKey.length > 7) {
    try {
      const sigLen = licenseKey.readUInt8(licenseKey.length - 2);
      if (
        (licenseKey.readUInt8(licenseKey.length - 1) & 7) === 0 &&
        licenseKey.readUInt8(licenseKey.length - 1) >> 3 === 0 &&
        licenseKey.length > 5 + sigLen
      ) {
        const payload = licenseKey.slice(2 + sigLen, licenseKey.length - 2);
        const license = JSON.parse(payload.toString("utf8"));
        const { t: to, g: apps, e: exp } = license;
        return { to, apps, exp };
      }
    } catch (e) {
      /* noop */
    }
    throw new Error("Invalid (corrupt) license key");
  }
  return null;
}

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

const plural = (nr, singular, plural = `${singular}s`) => {
  if (nr === 1) {
    return `${nr} ${singular}`;
  } else {
    return `${nr} ${plural}`;
  }
};

export const timeRemaining = exp => {
  const timeUntilExp = exp - Date.now();
  const absoluteTime = Math.abs(timeUntilExp);
  let expression;
  if (absoluteTime > 2 * WEEK) {
    const weeks = Math.floor(absoluteTime / WEEK);
    const days = Math.floor((absoluteTime % WEEK) / DAY);
    expression = `${plural(weeks, "week")} ${plural(days, "day")}`;
  } else if (absoluteTime > 2 * DAY) {
    const days = Math.floor(absoluteTime / DAY);
    const hours = Math.floor((absoluteTime % DAY) / HOUR);
    expression = `${plural(days, "day")} ${plural(hours, "hour")}`;
  } else if (absoluteTime > 2 * HOUR) {
    const hours = Math.floor(absoluteTime / HOUR);
    const minutes = Math.floor((absoluteTime % HOUR) / MINUTE);
    expression = `${plural(hours, "hour")} ${plural(minutes, "minute")}`;
  } else {
    const minutes = Math.floor(absoluteTime / MINUTE);
    const seconds = Math.floor((absoluteTime % MINUTE) / SECOND);
    expression = `${plural(minutes, "minute")} ${plural(seconds, "second")}`;
  }
  return timeUntilExp > 0
    ? `${expression} remaining`
    : `expired ${expression} ago`;
};
